import {
    SET_MULTI_LOADER,
    RESET_MULTI_LOADER
} from "@store/types/config";

const initialState = {
    multiLoader: [],
}

const configReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_MULTI_LOADER:
            const found = state.multiLoader.find(item => item.name === action.payload);

            if(found) {
                return {
                    ...state,
                    multiLoader: state.multiLoader.map(item => {
                        if (item.name === action.payload) {
                            return {
                                ...item,
                                isActive: true
                            }
                        }
                        return item;
                    }),
                };
            } else {
                return {
                    ...state,
                    multiLoader: [
                        ...state.multiLoader,
                        {
                            name: action.payload,
                            isActive: true,
                        }
                    ]
                };
            }

        case RESET_MULTI_LOADER:
            return {
                ...state,
                multiLoader: state.multiLoader.map(item => {
                    if (item.name === action.payload) {
                        return {
                            ...item,
                            isActive: false
                        }
                    }
                    return item;
                }),
            };
        default:
            return state;
    }
}

export default configReducer;